// import { EVENTS } from '@archetype-themes/utils/events'
// import { debounce } from '@archetype-themes/utils/utils'

// class PredictiveSearch extends HTMLElement {
//   constructor() {
//     super()
//     this.enabled = this.getAttribute('data-enabled')
//     this.context = this.getAttribute('data-context')
//     this.input = this.querySelector('input[type="search"]')
//     this.predictiveContainer = this.querySelector('#predictive-search')

//     this.defaultState = this.querySelector('[data-default-state]')
//     this.resultsState = this.querySelector('[data-predictive-results]')

//     this.recsNode = this.querySelector('[data-recommendations]')
//     this.suggestedNode = this.querySelector('[data-suggested-searches]')
//     this.defaultProdsNode = this.querySelector('[data-default-products]')
//     this.searchedProdsNode = this.querySelector('[data-searched-products]')
//     this.noResultsNode = this.querySelector('[data-no-results-message]')

//     this.closeBtn = this.querySelector('.btn--close-search')
//     this.screen = this.querySelector('[data-screen]')
//     this.SearchModal = this.closest('#SearchModal') || null

//     // listen for class change of 'modal--is-active on this.SearchModal
//     if (this.SearchModal) {
//       const observer = new MutationObserver((mutations) => {
//         mutations.forEach((mutation) => {
//           if (mutation.attributeName === 'class') {
//             const modalClass = mutation.target.className
//             if (modalClass.indexOf('modal--is-active') > -1) {
//               setTimeout(() => {
//                 this.input.focus()
//                 this.onChange()
//               }, 100)
//             }
//           }
//         })
//       })

//       observer.observe(this.SearchModal, {
//         attributes: true
//       })
//     }
//   }

//   connectedCallback() {
//     if (this.enabled === 'false') return

//     this.abortController = new AbortController()
//     // Open events
//     document.addEventListener(
//       EVENTS.predictiveSearchOpen,
//       (e) => {
//         if (e.detail.context !== this.context) return
//         this.classList.add('is-active')

//         // Wait for opening events to finish then apply focus
//         setTimeout(() => {
//           this.input.focus()
//           this.onChange()
//         }, 100)

//         document.body.classList.add('predictive-overflow-hidden')
//       },
//       { signal: this.abortController.signal }
//     )

//     // On typing
//     this.input.addEventListener('keydown', () => {
//       this.classList.add('is-active')
//     })

//     this.input.addEventListener(
//       'input',
//       debounce(300, (event) => {
//         this.onChange(event)
//       }).bind(this)
//     )

//     // Close events
//     document.addEventListener(
//       EVENTS.predictiveSearchClose,
//       () => {
//         this.close()
//       },
//       { signal: this.abortController.signal }
//     )

//     document.addEventListener(
//       'keydown',
//       (evt) => {
//         if (evt.keyCode === 27) this.close()
//       },
//       { signal: this.abortController.signal }
//     )

//     this.closeBtn.addEventListener(
//       'click',
//       (evt) => {
//         evt.preventDefault()
//         this.close()
//       },
//       { signal: this.abortController.signal }
//     )

//     this.screen?.addEventListener(
//       'click',
//       () => {
//         this.close()
//       },
//       { signal: this.abortController.signal }
//     )

//     document.addEventListener(EVENTS.headerSearchClose, () => {
//       this.close()
//     })
//   }

//   disconnectedCallback() {
//     this.abortController.abort()
//   }

//   onChange() {
//     const searchTerm = this.input.value.trim()
//     if (!searchTerm.length) {
//       this.showDefaultState()
//       return
//     }

//     this.getSearchResults(searchTerm)
//   }

//   getSearchResults(searchTerm) {
//     const searchObj = {
//       q: searchTerm,
//       'resources[type]': 'article,page,product',
//       'resources[limit]': 6,
//       'resources[limit_scope]': 'each',
//       'resources[options][unavailable_products]': 'last'
//     }

//     const params = this.paramUrl(searchObj)

//     fetch(`${window.Shopify.routes.root}search/suggest?${params}&section_id=search-results`)
//       .then((response) => {
//         if (!response.ok) {
//           const error = new Error(response.status)
//           this.close()
//           throw error
//         }

//         return response.text()
//       })
//       .then((text) => {
//         // const resultsMarkup = new DOMParser()
//         //   .parseFromString(text, 'text/html')
//         //   .querySelector('#shopify-section-search-results').innerHTML
//         const parser = new DOMParser()
//           .parseFromString(text, 'text/html')
//         const isNoResults = parser.querySelector('.predictive-search-results--none') !== null
//         if (isNoResults) {
//           if (this.noResultsNode) {
//             this.noResultsNode.style.display = 'block'
//           }

//           if (this.recsNode) this.recsNode.style.display = 'block'
//           if (this.suggestedNode) {
//             this.suggestedNode.style.display = 'none'
//             this.suggestedNode.innerHTML = ''
//           }
//           if (this.defaultProdsNode) this.defaultProdsNode.style.display = 'contents'
//           if (this.searchedProdsNode) {
//             this.searchedProdsNode.style.display = 'none'
//             this.searchedProdsNode.innerHTML = ''
//           }
//         } else{
//           if (this.noResultsNode) this.noResultsNode.style.display = 'none'
//            const apiSuggested = parser.querySelector('#api-suggested-searches')?.innerHTML || ''
//           const apiProducts = parser.querySelector('#api-searched-products')?.innerHTML || ''
//           if (this.recsNode) this.recsNode.style.display = 'none'
//           if (this.suggestedNode) {
//             this.suggestedNode.innerHTML = apiSuggested
//             this.suggestedNode.style.display = 'block'
//           }

//           if (this.defaultProdsNode) this.defaultProdsNode.style.display = 'none'
//           if (this.searchedProdsNode) {
//             this.searchedProdsNode.innerHTML = apiProducts
//             this.searchedProdsNode.style.display = 'contents' 
//           }
//         }
//         this.classList.add('is-active')
//         // this.predictiveSearchResults.innerHTML = resultsMarkup
//         // this.resultsState.innerHTML = resultsMarkup
//         // this.showResultsState()
//       })
//       .catch((error) => {
//         this.close()
//         throw error
//       })
//   }

//   showDefaultState() {
//     if (this.predictiveContainer) this.predictiveContainer.style.display = 'block'
//     if (this.defaultState) this.defaultState.style.display = 'block'

//     if (this.noResultsNode) {
//       this.noResultsNode.style.display = 'none'
//     }
//     if (this.recsNode) this.recsNode.style.display = 'block'
//     if (this.suggestedNode) {
//       this.suggestedNode.style.display = 'none'
//       this.suggestedNode.innerHTML = ''
//     }

//     if (this.defaultProdsNode) this.defaultProdsNode.style.display = 'contents'
//     if (this.searchedProdsNode) {
//       this.searchedProdsNode.style.display = 'none'
//       this.searchedProdsNode.innerHTML = ''
//     }
    
//     this.classList.add('is-active')
//   }
//   showResultsState() {
//     this.predictiveContainer.style.display = 'block'
//     if (this.defaultState) this.defaultState.style.display = 'none'
//     if (this.resultsState) this.resultsState.style.display = 'block'
//     this.classList.add('is-active')
//   }
//   close() {
//     this.predictiveContainer.style.display = 'none'
//     if (this.defaultState) this.defaultState.style.display = 'flex'
//     if (this.resultsState) {
//       this.resultsState.style.display = 'none'
//       this.resultsState.innerHTML = ''
//     }
//     this.input.value = ''
//     this.classList.remove('is-active')
//     document.body.classList.remove('predictive-overflow-hidden')
//     if (this.contains(document.activeElement)) document.activeElement.blur()
//     /**
//      * @event predictive-search:close-all
//      * @description Fired when the predictive search is closed.
//      */
//     this.dispatchEvent(new CustomEvent(EVENTS.predictiveSearchCloseAll, { bubbles: true }))
//   }

//   paramUrl(obj) {
//     return Object.keys(obj)
//       .map(key => key + '=' + encodeURIComponent(obj[key]))
//       .join('&')
//   }
// }

// customElements.define('predictive-search', PredictiveSearch)



import { EVENTS } from '@archetype-themes/utils/events'
import { debounce } from '@archetype-themes/utils/utils'

document.addEventListener('DOMContentLoaded', function () {
  let rootEl = document.querySelector('predictive-search');
  if (rootEl) {
    // 如果运气好，页面加载完它就在，直接初始化
    initPredictiveSearch(rootEl);
  } else {
    const observer = new MutationObserver((mutations, obs) => {
      rootEl = document.querySelector('predictive-search');
      if (rootEl) {
        initPredictiveSearch(rootEl);
        obs.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function initPredictiveSearch(rootEl) {
    const enabled = rootEl.getAttribute('data-enabled');
    if (enabled === 'false') return;

    const context = rootEl.getAttribute('data-context');
    
    const input = rootEl.querySelector('input[type="search"]');
    const predictiveContainer = rootEl.querySelector('#predictive-search');
    const defaultState = rootEl.querySelector('[data-default-state]');
    const resultsState = rootEl.querySelector('[data-predictive-results]');
    const recsNode = rootEl.querySelector('[data-recommendations]');
    const suggestedNode = rootEl.querySelector('[data-suggested-searches]');
    const defaultProdsNode = rootEl.querySelector('[data-default-products]');
    const searchedProdsNode = rootEl.querySelector('[data-searched-products]');
    const noResultsNode = rootEl.querySelector('[data-no-results-message]');
    const closeBtn = rootEl.querySelector('.btn--close-search');
    const screen = rootEl.querySelector('[data-screen]');
    const SearchModal = rootEl.closest('#SearchModal') || null;
    let inputValue = null

    const abortController = new AbortController();
    document.querySelectorAll('form[action="/search"]').forEach(form => {
      form.addEventListener('submit', function(e) {
        const input = form.querySelector('input[name="q"]');
        if (input && input.value.trim() === '') {
          e.preventDefault();
          window.location.href = window.Shopify.routes.root + 'search';
        }
      });
    });

    // 初始监听：MutationObserver 监听 Modal 状态
    if (SearchModal) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'class') {
            const modalClass = mutation.target.className;
            if (modalClass.indexOf('modal--is-active') > -1) {
              setTimeout(() => {
                if (input) input.focus();
                onChange();
              }, 100);
            }
          }
        });
      });

      observer.observe(SearchModal, {
        attributes: true
      });
    }

    
    document.addEventListener(
      EVENTS.predictiveSearchOpen,
      (e) => {
        if (e.detail.context !== context) return;
        rootEl.classList.add('is-active');

        setTimeout(() => {
          if (input) input.focus();
          onChange();
        }, 100);

        document.body.classList.add('predictive-overflow-hidden');
      },
      { signal: abortController.signal }
    );

    if (input) {
      input.addEventListener('keydown', () => {
        rootEl.classList.add('is-active');
      });

      input.addEventListener(
        'input',
        debounce(200, (event) => {
          onChange(event);
        })
      );
    }

    // 关闭事件集合
    document.addEventListener(
      EVENTS.predictiveSearchClose,
      () => closeSearch(),
      { signal: abortController.signal }
    );

    document.addEventListener(
      'keydown',
      (evt) => {
        if (evt.keyCode === 27) closeSearch();
      },
      { signal: abortController.signal }
    );

    if (closeBtn) {
      closeBtn.addEventListener(
        'click',
        (evt) => {
          evt.preventDefault();
          closeSearch();
        },
        { signal: abortController.signal }
      );
    }

    if (screen) {
      screen.addEventListener(
        'click',
        () => closeSearch(),
        { signal: abortController.signal }
      );
    }

    document.addEventListener(EVENTS.headerSearchClose, () => {
      closeSearch();
    });

    function onChange() {
      if (!input) return;
      const searchTerm = input.value.trim();
      if (!searchTerm.length) {
        showDefaultState();
        return;
      }

      getSearchResults(searchTerm);
    }

    function getSearchResults(searchTerm) {
      const searchObj = {
        q: searchTerm,
        'resources[type]': 'article,page,product',
        'resources[limit]': 6,
        'resources[limit_scope]': 'each',
        'resources[options][unavailable_products]': 'last'
      };

      const params = paramUrl(searchObj);

      fetch(`${window.Shopify.routes.root}search/suggest?${params}&section_id=search-results`)
        .then((response) => {
          if (!response.ok) {
            const error = new Error(response.status);
            closeSearch();
            throw error;
          }
          return response.text();
        })
        .then((text) => {
          const parser = new DOMParser().parseFromString(text, 'text/html');
          const isNoResults = parser.querySelector('.predictive-search-results--none') !== null;
          
          if (isNoResults) {
            // 显示无结果提示
            if (noResultsNode) {
               noResultsNode.style.display = 'block';
            }
            if (recsNode) recsNode.style.display = 'block';
            
            if (suggestedNode) {
              suggestedNode.style.display = 'none';
              suggestedNode.innerHTML = '';
            }
            if (defaultProdsNode) defaultProdsNode.style.display = 'contents';
            if (searchedProdsNode) {
              searchedProdsNode.style.display = 'none';
              searchedProdsNode.innerHTML = '';
            }
          } else {
            if (noResultsNode) noResultsNode.style.display = 'none';
            
            const apiSuggested = parser.querySelector('#api-suggested-searches')?.innerHTML || '';
            const apiProducts = parser.querySelector('#api-searched-products')?.innerHTML || '';
            
            if (recsNode) recsNode.style.display = 'none';
            if (suggestedNode) {
              suggestedNode.innerHTML = apiSuggested;
              suggestedNode.style.display = 'block';
            }

            if (defaultProdsNode) defaultProdsNode.style.display = 'none';
            if (searchedProdsNode) {
              searchedProdsNode.innerHTML = apiProducts;
              searchedProdsNode.style.display = 'contents';
            }
          }
          rootEl.classList.add('is-active');
        })
        .catch((error) => {
          closeSearch();
          throw error;
        });
    }

    function showDefaultState() {
      if (predictiveContainer) predictiveContainer.style.display = 'block';
      if (defaultState) defaultState.style.display = 'block';

      if (noResultsNode) {
        noResultsNode.style.display = 'none';
      }
      if (recsNode) recsNode.style.display = 'block';
      if (suggestedNode) {
        suggestedNode.style.display = 'none';
        suggestedNode.innerHTML = '';
      }

      if (defaultProdsNode) defaultProdsNode.style.display = 'contents';
      if (searchedProdsNode) {
        searchedProdsNode.style.display = 'none';
        searchedProdsNode.innerHTML = '';
      }
      
      rootEl.classList.add('is-active');
    }

    function showResultsState() {
      if (predictiveContainer) predictiveContainer.style.display = 'block';
      if (defaultState) defaultState.style.display = 'none';
      if (resultsState) resultsState.style.display = 'block';
      rootEl.classList.add('is-active');
    }

    function closeSearch() {
      if (predictiveContainer) predictiveContainer.style.display = 'none';
      if (defaultState) defaultState.style.display = 'flex';
      if (resultsState) {
        resultsState.style.display = 'none';
        resultsState.innerHTML = '';
      }
      if (input) input.value = '';
      rootEl.classList.remove('is-active');
      document.body.classList.remove('predictive-overflow-hidden');
      
      if (rootEl.contains(document.activeElement)) document.activeElement.blur();
      
      rootEl.dispatchEvent(new CustomEvent(EVENTS.predictiveSearchCloseAll, { bubbles: true }));
    }

    function paramUrl(obj) {
      return Object.keys(obj)
        .map(key => key + '=' + encodeURIComponent(obj[key]))
        .join('&');
    }
  }
});